import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/LeafletMap/LeafletMap.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/LeafletMap/LeafletMap.ts';

export const prototypeName = 'qKApwbrXxkTevkGM4pydS8y22Ndljqs7kQqQ7zw4I3bpkRlRqMT4yQyGLA1yIjGOVQX0ZecG12por';
export {styles};
export {script};